export const BITCOIN_FOUNDATION_DATE = new Date("07-01-2009");
export const BITCOIN_API_BEGIN_DATE = new Date("07-17-2010");
